var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3285 1.22006C12.1095 0.439015 13.3758 0.439015 14.1569 1.22006C14.9379 2.00111 14.9379 3.26744 14.1569 4.04849L13.364 4.84138L10.5356 2.01296L11.3285 1.22006Z",
    fill: "#6C727F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12136 3.42717L0.742676 11.8059V14.6343H3.5711L11.9498 6.2556L9.12136 3.42717Z",
    fill: "#6C727F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d1d9da05e3e63d811bade100246eccb0.svg";
export { ForwardRef as ReactComponent };